export default "__VITE_ASSET__JtExw7o1__"